import { render, staticRenderFns } from "./MessagesPage.vue?vue&type=template&id=6e0f4f6e&scoped=true&"
import script from "./MessagesPage.vue?vue&type=script&lang=js&"
export * from "./MessagesPage.vue?vue&type=script&lang=js&"
import style0 from "./MessagesPage.vue?vue&type=style&index=0&id=6e0f4f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f4f6e",
  null
  
)

export default component.exports